/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_DrsTransactionDto } from '../models/Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_DrsTransactionDto';
import type { Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_TransferDrsToStreetNameRequestDto } from '../models/Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_TransferDrsToStreetNameRequestDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DrsToStreetNameTransferService {

    /**
     * @param awardType 
     * @returns Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_DrsTransactionDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDrsToStreetNameTransferTransactionsForDrsToStreetNameTransfer(
awardType?: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_DrsTransactionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/drs-to-street-name-transfer/transactions-for-drs-to-street-name-transfer',
            query: {
                'awardType': awardType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppDrsToStreetNameTransferTransferDrsToStreetName(
requestBody?: Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_TransferDrsToStreetNameRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/drs-to-street-name-transfer/transfer-drs-to-street-name',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
